import { ComponentPropsWithoutRef, forwardRef } from "react";
import * as styles from "./WrapperFormRoot.css";
import clsx from "clsx";

type WrapperFormRootProps = ComponentPropsWithoutRef<"div">;

export const WrapperFormRoot = forwardRef<
  HTMLDivElement,
  WrapperFormRootProps
>(({ children, className, ...props }, ref) => {
  return (
    <div className={clsx(className, styles.root)} {...props} ref={ref}>
      {children}
    </div>
  );
});
